import { LOADING } from '../constants'

export default function loadingStatuss(data) {
	// console.log('loadingStatuss',data)
  return {
    type: LOADING,
    data
  }
}



// WEBPACK FOOTER //
// ./src/actions/LoadingActions.js